var _mask, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuBurgerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1_1110",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 10C16.0001 13.3137 13.3138 16 10.0001 16H6.00014C2.68643 16 0.000137329 13.3137 0.000137329 10V6C0.000137329 2.68629 2.68643 0 6.00014 0L10.0001 0C13.3138 0 16.0001 2.68629 16.0001 6V10Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 10C16.0001 13.3137 13.3138 16 10.0001 16H6.00014C2.68643 16 0.000137329 13.3137 0.000137329 10V6C0.000137329 2.68629 2.68643 0 6.00014 0L10.0001 0C13.3138 0 16.0001 2.68629 16.0001 6V10Z",
    fill: "#F8FAFC",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 16V15L6.00014 15V16V17H10.0001V16ZM0.000137329 10H1.00014L1.00014 6H0.000137329H-0.999863V10H0.000137329ZM6.00014 0V1L10.0001 1V0V-1H6.00014V0ZM16.0001 6H15.0001L15.0001 10H16.0001H17.0001V6H16.0001ZM10.0001 0V1C12.7616 1 15.0001 3.23858 15.0001 6H16.0001H17.0001C17.0001 2.13401 13.8661 -1 10.0001 -1V0ZM0.000137329 6H1.00014C1.00014 3.23858 3.23871 1 6.00014 1V0V-1C2.13414 -1 -0.999863 2.13401 -0.999863 6H0.000137329ZM6.00014 16V15C3.23871 15 1.00014 12.7614 1.00014 10H0.000137329H-0.999863C-0.999863 13.866 2.13414 17 6.00014 17V16ZM10.0001 16V17C13.8661 17 17.0001 13.866 17.0001 10H16.0001H15.0001C15.0001 12.7614 12.7616 15 10.0001 15V16Z",
    fill: "#F8FAFC",
    fillOpacity: 0.2,
    mask: "url(#path-1-inside-1_1_1110)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00014 4L10.0001 8L6.00014 12",
    fill: "#F8FAFC",
    fillOpacity: 0.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00014 4L10.0001 8L6.00014 12",
    stroke: "#F8FAFC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBurgerIcon);
export default __webpack_public_path__ + "static/media/menu-burger-icon.d0e5365752b0d5c9fa0b885a01e2c728.svg";
export { ForwardRef as ReactComponent };